import { render, staticRenderFns } from "./TraceTable.vue?vue&type=template&id=52cd8954&scoped=true&"
import script from "./TraceTable.vue?vue&type=script&lang=js&"
export * from "./TraceTable.vue?vue&type=script&lang=js&"
import style0 from "./TraceTable.vue?vue&type=style&index=0&id=52cd8954&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd8954",
  null
  
)

export default component.exports